import api from '@pray/shared/utils/api';

export async function deleteTagLocale(tagId: string, localeCode: string) {
  const url = `/web/studio/tags/${tagId}/locales/${localeCode}`;

  await api.executeDeleteRequest(url);

  return { success: true };
}
